let requestPolyfill: (
  callback: (arg1: {didTimeout: boolean; timeRemaining: () => number}) => void,
  options?: {
    timeout: number;
  },
  // @ts-expect-error TS2552
) => IdleCallbackID;
// @ts-expect-error TS2552
let cancelPolyfill: (id: IdleCallbackID) => void;

if (typeof requestIdleCallback === 'function') {
  requestPolyfill = requestIdleCallback;
  cancelPolyfill = cancelIdleCallback;
} else {
  requestPolyfill = (
    callback: (arg1: {
      didTimeout: boolean;
      timeRemaining: () => number;
    }) => unknown,
    options?: {
      timeout: number;
    },
  ) => {
    const timeout = options?.timeout || 5000;
    return setTimeout(() => {
      callback({
        didTimeout: true,
        timeRemaining: () => 0,
      });
    }, timeout);
  };

  cancelPolyfill = clearTimeout;
}

export {
  requestPolyfill as requestIdleCallback,
  cancelPolyfill as cancelIdleCallback,
};
